import { useEffect, useRef } from 'react'

export default function Modal({ size = 'md', children, actions, title, onHide }) {
  const modal = useRef()

  useEffect(() => {
    const modalEl = document.getElementById('modal')
    // eslint-disable-next-line no-undef
    modal.current = new bootstrap.Modal(modalEl)
    modalEl.addEventListener('hidden.bs.modal', onHide)

    modal.current.show()

    return () => {
      modal.current.hide()
    }
  }, [onHide])

  return (
    <div
      className="modal fade"
      id="modal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
    >
      <div className={`modal-dialog modal-${size}`}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="staticBackdropLabel">
              {title}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Cancel"
            />
          </div>
          <div className="modal-body">{children}</div>
          <div className="modal-footer">{actions}</div>
        </div>
      </div>
    </div>
  )
}
